import createRoute from '@widesk-ui/tools/createRoute';
import SliderModel from '@models/shop/SliderModel';

export default createRoute.dashboard('/sliders', 'shop', 'SliderDashboard', SliderModel.localize());